export enum CustomerFields {
	ID = "id",
	NAME = "name",
	LEGAL_NAME = "legal_name",
	DOCUMENT = "document",
	DOCUMENT_TYPE = "documentType",
	EMAIL = "email",
	PHONE = "contactPhone"
}

export enum CustomerDocumentType {
	CPF = "CPF",
	CNPJ = "CNPJ"
}

export type CustomerProps = {
	[CustomerFields.ID]: string;
	[CustomerFields.NAME]: string;
	[CustomerFields.DOCUMENT]: string;
	[CustomerFields.DOCUMENT_TYPE]?: CustomerDocumentType;
	[CustomerFields.EMAIL]: string;
	[CustomerFields.PHONE]: string;
};
